import Link from 'next/link';
import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import type { ISearchFallbackScenariosProps } from '..';

import { ScSearchFallbackScenario } from '../styled';

type WithdrawScenarioProps = ISearchFallbackScenariosProps;

export const PromocodeScenario: React.FC<WithdrawScenarioProps> = ({
  sendSearchResultAppearance,
  closeModal,
}) => {
  const { t } = useTranslation('lobby');

  useEffect(() => {
    sendSearchResultAppearance({ status: 'custom' });
  }, []);

  return (
    <ScSearchFallbackScenario>
      <div className="text">
        <p>{t('searchFallback.title')}</p>
        <p>
          <Trans
            components={{
              l: (
                <Link
                  className="link"
                  href="/promotions"
                  onClick={closeModal}
                />
              ),
              s: <strong />,
            }}
            i18nKey="searchFallback.subtitle.promocode"
            ns="lobby"
          />
        </p>
        <p>
          <Trans
            components={{
              l: (
                <Link
                  className="link"
                  href="/promotions?tab=all-offers&block=promocode"
                  onClick={closeModal}
                />
              ),
              s: <strong />,
            }}
            i18nKey="searchFallback.subtitle2.promocode"
            ns="lobby"
          />
        </p>
      </div>
    </ScSearchFallbackScenario>
  );
};
